import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

import { AuthService } from '../../core/auth/auth.service';

@Component({
  selector: 'app-home',
  imports: [RouterOutlet, RouterLink, RouterLinkActive],
  templateUrl: './home.component.html',
  styles: '',
})
export class HomeComponent {
  private authService = inject(AuthService);

  isAdmin = () => {
    return this.authService.doesUserHasRole(['SUPERADMIN', 'ADMIN']);
  };

  logout() {
    this.authService.logout();
  }

  closeSidebar() {}
}
